import { PipelineComponentName } from '@projectTypes/Pipeline';
import EntityExtractorComponent from './EntityExtractorComponent';

export default class MitieEntityExtractor extends EntityExtractorComponent {
  requiredComponentName = PipelineComponentName.MitieNLP;
}
